import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { DivisionPicker } from './DivisionPickerExtension';

export const DivisionPickerFieldExtension = FormFieldBlueprint.make({
  name: 'division-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'DivisionPicker',
        component: DivisionPicker,
      }),
  },
});
